import ShopifyProduct from "../models/ShopifyProduct";

//https://medium.com/geekculture/how-to-publish-content-with-the-instagram-graph-api-806ec9c56588
export default {

    facebook_app_id:  "1342830669594757",
    facebook_page_id: "100089193584381",
    instagram_account_id: "17841451518821060",
    facebook_access_token: null,
    
    initFacebookSDK(){ console.log("facebook initSDK");
        return new Promise((resolve) => {
            // Wait for the Facebook SDK to initialize before starting the React app.
            window.fbAsyncInit = () => {
                window.FB.init({
                    appId: this.facebook_app_id,
                    cookie: true,
                    xfbml: true,
                    version: "v2.4", //"v10.0",
                });

                resolve();
            };

            // Load the Facebook SDK script.
            (function (d, s, id) {
                let js, fjs = d.getElementsByTagName(s)[0];
                if (d.getElementById(id)) { return; }
                js = d.createElement(s);
                js.id = id;
                js.src = "https://connect.facebook.net/en_US/sdk.js";
                fjs.parentNode.insertBefore(js, fjs);
            })(document, "script", "facebook-jssdk");
        });
    },


    // ----------------------------------
    // -------------  Login  ------------
    // ----------------------------------

    login(){
        window.FB.login((response) => {
                if (response.authResponse) {
                    this.facebook_access_token = response.authResponse?.accessToken;
                    console.log("token", this.facebook_access_token);
                    alert("You are logged in &amp; cookie set!");
                } else {
                    alert("User cancelled login or did not fully authorize.");
                }
            },
            { scope: "instagram_basic,pages_show_list,instagram_content_publish", }
        );
        return false;
    },

    logout(){
        return new Promise((resolve) => {
            window.FB.logout(() => {
                this.facebook_access_token = null;
                resolve();
            });
        });
    },

    async updateAccessToken() {
        return new Promise((resolve) => {
            window.FB.getLoginStatus((response) => {
                console.log('response', response);
                this.facebook_access_token = response.authResponse?.accessToken;
                console.log("token", this.facebook_access_token);
                resolve(this.facebook_access_token);
            });
        });
    },

    // ---------------------------------------------
    // -------------  Utility Requests  ------------
    // ---------------------------------------------

    getFacebookProfile(){
        window.FB.api(
            "me/profile",
            { access_token: this.facebook_access_token },
            (response) => {
                console.log(response);
            }
        );
    },

    getFacebookPages(){
        window.FB.api(
            "me/accounts",
            { access_token: this.facebook_access_token },
            (response) => {
                console.log(response);
            }
        );
    },

    getInstagramAccountId(){
        window.FB.api(
            this.facebook_page_id,
            {
                access_token: this.facebook_access_token ,
                fields: "instagram_business_account",
            },
            (response) => {
                console.log("inst", response);
                this.instagram_account_id = response.instagram_business_account.id;
                console.log("this.instagram_account_id", this.instagram_account_id);
            }
        );
    },




    // ---------------------------------------------
    // ---------------  Instagram Post  ------------
    // ---------------------------------------------

    async createInstagramPost(product){
        const mediaObjectContainerId = await this.createMediaObjectContainer(product);
        const id = await this.publishMediaObjectContainer(mediaObjectContainerId);
        return id;
    },

    createMediaObjectContainer(product){
        return new Promise((resolve) => {
            window.FB.api(
                `${this.instagram_account_id}/media`,
                "POST",
                {
                    access_token: this.facebook_access_token,
                    image_url: product.cropped_image_url,
                    caption: product.title,
                },
                (response) => {

                    console.log("createMediaObjectContainer.response", response);
                    resolve(response.id);
                }
            );
        });
    },

    publishMediaObjectContainer(mediaObjectContainerId){
        return new Promise((resolve) => {
            window.FB.api(
                `${this.instagram_account_id}/media_publish`,
                "POST",
                {
                    access_token: this.facebook_access_token,
                    creation_id: mediaObjectContainerId,
                },
                (response) => {
                    console.log("publishMediaObjectContainer.response", response);
                    resolve(response.id);
                }
            );
        });
    }
    
    /*
 //   const [imageUrl, setImageUrl] = useState("");
  //  const [postCaption, setPostCaption] = useState("");
   // const [isSharingPost, setIsSharingPost] = useState(false);
   // const [facebookUserAccessToken, setFacebookUserAccessToken] = useState("");


    // Check if the user is authenticated with Facebook
    /*useEffect(() => {
        window.FB.getLoginStatus((response) => {
            setFacebookUserAccessToken(response.authResponse?.accessToken);
        });
    }, []);

    const logInToFB = () => {
        window.FB.login(
            (response) => {
                setFacebookUserAccessToken(response.authResponse?.accessToken);
            },
            {
                // Scopes that allow us to publish content to Instagram
                scope: "instagram_basic,pages_show_list",
            }
        );
    };

    const logOutOfFB = () => {
        window.FB.logout(() => {
            setFacebookUserAccessToken(undefined);
        });
    };

    const getFacebookPages = () => {
        return new Promise((resolve) => {
            window.FB.api(
                "me/accounts",
                { access_token: facebookUserAccessToken },
                (response) => {
                    resolve(response.data);
                }
            );
        });
    };

    const getInstagramAccountId = (facebookPageId) => {
        return new Promise((resolve) => {
            window.FB.api(
                facebookPageId,
                {
                    access_token: facebookUserAccessToken,
                    fields: "instagram_business_account",
                },
                (response) => {
                    resolve(response.instagram_business_account.id);
                }
            );
        });
    };

    const createMediaObjectContainer = (instagramAccountId) => {
        return new Promise((resolve) => {
            window.FB.api(
                `${instagramAccountId}/media`,
                "POST",
                {
                    access_token: facebookUserAccessToken,
                    image_url: imageUrl,
                    caption: postCaption,
                },
                (response) => {
                    resolve(response.id);
                }
            );
        });
    };

    const publishMediaObjectContainer = (
        instagramAccountId,
        mediaObjectContainerId
    ) => {
        return new Promise((resolve) => {
            window.FB.api(
                `${instagramAccountId}/media_publish`,
                "POST",
                {
                    access_token: facebookUserAccessToken,
                    creation_id: mediaObjectContainerId,
                },
                (response) => {
                    resolve(response.id);
                }
            );
        });
    };

    const shareInstagramPost = async () => {
        setIsSharingPost(true);
        const facebookPages = await getFacebookPages();
        const instagramAccountId = await getInstagramAccountId(facebookPages[0].id);
        const mediaObjectContainerId = await createMediaObjectContainer(
            instagramAccountId
        );

        await publishMediaObjectContainer(
            instagramAccountId,
            mediaObjectContainerId
        );

        setIsSharingPost(false);

        // Reset the form state
        setImageUrl("");
        setPostCaption("");
    };
*/
}

//export default Facebook;